import { ChronotrackApi } from '../../anuket-http';
import { Observable } from 'rx';

const MediaNoble = {
  getPhotosAndVideos: ({eventId, entryId}) => {
    const streamId = `GetPhotosAndVideos-${eventId}-${entryId}`;
    return ChronotrackApi.memoizeQuery(streamId, `results/${eventId}/entry/${entryId}`)
      .map((msg) => {
        return {
          photos: msg.photos,
          videos: msg.videos
        };
      });
  }
};

export default MediaNoble;



/** WEBPACK FOOTER **
 ** ./lib/anuket/nobles/MediaNoble.js
 **/